import moment from 'moment-timezone';

export class PricingCopilotMatrixOverviewChart {
	public category: string;
	public salesMonth: string | Date;
	public value: number;

	constructor(pricingCopilotMatrixOverviewChart: PricingCopilotMatrixOverviewChart) {
		Object.assign(this, pricingCopilotMatrixOverviewChart);

		this.salesMonth = this.salesMonth ? new Date(moment(this.salesMonth).format('MMM DD, YYYY 00:00:00 a')) : this.salesMonth;
	}
}
